"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
function useFocus(size, onOptionChange) {
  var _useState = (0, _react.useState)(-1),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentFocus = _useState2[0],
    setCurrentFocus = _useState2[1];
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    if (e.keyCode === 40) {
      // Down arrow
      e.preventDefault();
      if (currentFocus === size - 1) {
        return;
      }
      setCurrentFocus(currentFocus === size - 1 ? 0 : currentFocus + 1);
    } else if (e.keyCode === 38) {
      // Up arrow
      e.preventDefault();
      if (currentFocus <= 0) {
        return;
      }
      setCurrentFocus(currentFocus === 0 ? size - 1 : currentFocus - 1);
    } else if (e.keyCode === 32 || e.keyCode === 13) {
      // if currentFocus is -1, it means no item is selected so return
      // most likely the user is typing in the search input
      if (currentFocus === -1) return;
      // select/Deselect menu items - using Space-key and Enter -Key
      e.preventDefault();
      if (e.target.value) {
        onOptionChange(e, !e.target.checked);
      }
    } else if (e.keyCode === 9) {
      setCurrentFocus(-1);
    }
  }, [size, currentFocus, onOptionChange, setCurrentFocus]);
  (0, _react.useEffect)(function () {
    document.addEventListener('keydown', handleKeyDown, false);
    return function () {
      document.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [handleKeyDown]);
  return [currentFocus, setCurrentFocus];
}
var _default = useFocus;
exports["default"] = _default;